/**
 * Protected Route Component
 * 
 * Handles access control for NOC-specific routes.
 */

import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { isNOCUser } from '../utils/shiftUtils';

const ProtectedRoute = ({ 
  component: Component, 
  currentUser = {}, 
  requiresNOC = false,
  ...rest 
}) => {
  // Check if user has access
  if (requiresNOC) {
    console.log('ProtectedRoute - currentUser:', currentUser);
    console.log('ProtectedRoute - groups:', currentUser.groups);
    const isNOC = isNOCUser(currentUser.groups || []);
    console.log('ProtectedRoute - isNOC:', isNOC);
    
    if (!isNOC) {
      return (
        <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
          <Box>
            <Typography variant="h4" sx={{ mb: 2 }}>
              Access Denied
            </Typography>
            <Typography variant="body1" color="textSecondary" sx={{ mb: 3 }}>
              You don't have permission to access this page.
              Only NOC and Admin users can access shift and vacation management.
            </Typography>
            <Button 
              variant="contained" 
              href="/"
            >
              Go to Dashboard
            </Button>
          </Box>
        </Container>
      );
    }
  }

  return <Component {...rest} currentUser={currentUser} />;
};

export default ProtectedRoute;
